import React from 'react';
import { EARNING_RULE_TYPES, LOYALTY_DEFAULTS } from './constants';
import { constructEarningRule, isLightColor } from './utils';
import LoyaltyEarningsOrderIcon from '../../assets/images/loyalty-earnings-order.svg';
import LoyaltyEarningsAmountIcon from '../../assets/images/loyalty-earnings-amount.svg';
import LoyaltyEarningsReferralIcon from '../../assets/images/loyalty-earnings-order.svg';

// Get icon based on earning type - using data URIs for now as placeholders
const getIconForEarningType = (type) => {
  switch (type.toString()) {
    case EARNING_RULE_TYPES.ORDER:
      return LoyaltyEarningsOrderIcon;
    case EARNING_RULE_TYPES.AMOUNT:
      return LoyaltyEarningsAmountIcon;
    case EARNING_RULE_TYPES.REFERRAL:
      return LoyaltyEarningsReferralIcon;
    default:
      return LoyaltyEarningsReferralIcon;
  }
};

const EarningItem = ({
  earning,
  themeColors,
  pointsTerminology = LOYALTY_DEFAULTS.POINTS_TERMINOLOGY,
  currency = LOYALTY_DEFAULTS.CURRENCY_SYMBOL,
}) => {
  const { type } = earning;

  // Get earning rule text using the utility function
  const ruleText = constructEarningRule(earning, currency);

  // Define the linear gradient style using themeColors
  const iconBackgroundStyle = {
    background: `linear-gradient(to bottom, ${
      isLightColor(themeColors.backgroundColor)
        ? themeColors.mainTextColor
        : themeColors.backgroundColor
    } 0%, rgb(251, 251, 251) 150%)`,
  };

  return (
    <div className='earning-item'>
      <div className='earning-item-icon' style={iconBackgroundStyle}>
        <img src={getIconForEarningType(type)} alt='Earning' />
      </div>
      <div className='earning-item-content'>
        <div className='earning-item-title'>{ruleText}</div>
        {/* <div className="earning-item-description">Lorem ipsum dolor sit amet, ligula suspendisse.</div> */}
      </div>
    </div>
  );
};

export default EarningItem;
